export type OnboardingItemKey =
	| "customize_branding"
	| "create_form"
	| "share_form"
	| "collect_testimonial"
	| "setup_widget"
	| "embed_on_website";

export type SecondaryOnboardingItemKey =
	| "watch_demo_video"
	| "invite_team_members"
	| "setup_wall_of_love"
	| "setup_tags"
	| "import_reviews"
	| "remove_branding";

export interface OnboardingRecord {
	id: string;
	step: string;
	completed_at: string;
}

export interface OnboardingChecklistItem {
	key: OnboardingItemKey;
	label: string;
	description: string;
	route: string;
}

export interface SecondaryChecklistItem {
	key: SecondaryOnboardingItemKey;
	label: string;
	description: string;
	route?: string;
	href?: string;
}

export const CHECKLIST_ITEMS: OnboardingChecklistItem[] = [
	{ key: "customize_branding", label: "Customize branding", description: "Upload your logo and set brand colors to personalize your workspace.", route: "branding" },
	{ key: "create_form", label: "Create a form", description: "Build a feedback form to collect testimonials from your customers.", route: "forms" },
	{ key: "share_form", label: "Share the form", description: "Share your form link with customers to start collecting testimonials.", route: "forms" },
	{ key: "collect_testimonial", label: "Collect your first testimonial", description: "Receive a testimonial through your form or add one manually.", route: "reviews" },
	{ key: "setup_widget", label: "Setup widget", description: "Create a widget to showcase your testimonials on your website.", route: "widgets" },
	{ key: "embed_on_website", label: "Embed on the website", description: "Add the widget embed code to your website to display testimonials.", route: "widgets" },
];

export const SECONDARY_CHECKLIST_ITEMS: SecondaryChecklistItem[] = [
	{ key: "watch_demo_video", label: "Watch the demo video", description: "See a quick walkthrough of how everything works.", href: "https://shashanksn.neetorecord.com/watch/83ac193b39092b7f20d4" },
	{ key: "invite_team_members", label: "Invite your team members", description: "Collaborate with your team to manage testimonials together.", route: "teams" },
	{ key: "setup_wall_of_love", label: "Setup your wall of love", description: "Create a beautiful page to showcase your best testimonials.", route: "wall-of-love" },
	{ key: "setup_tags", label: "Setup tags", description: "Organize testimonials with tags for easy filtering.", route: "tags" },
	{ key: "import_reviews", label: "Import your existing reviews", description: "Bring in reviews from G2, Capterra, or CSV files.", route: "import" },
	{ key: "remove_branding", label: "Remove Say About Us branding", description: "Upgrade to remove branding and unlock premium features.", route: "billing" },
];
